export function isAdminLoginPage() {
  return /\/admin-login\/?$/.test(window.location.pathname);
}

export function consumeAdminLoginToken() {
  const key = '__ondivanConsumeAdminToken';
  const consume = window[key];
  delete window[key];
  return typeof consume === 'function' ? consume() : undefined;
}
